import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { initializeListeners, createDidUpdateCallback, createNavigationPropConstructor } from './middleware';

function createReduxContainer(Navigator) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
  var didUpdateCallback = createDidUpdateCallback(key);
  var propConstructor = createNavigationPropConstructor(key);

  var NavigatorReduxWrapper =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(NavigatorReduxWrapper, _React$PureComponent);

    function NavigatorReduxWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, NavigatorReduxWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavigatorReduxWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "getCurrentNavigation", function () {
        return _this.currentNavProp;
      });

      return _this;
    }

    _createClass(NavigatorReduxWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        initializeListeners(key, this.props.state);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        didUpdateCallback();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            dispatch = _this$props.dispatch,
            state = _this$props.state,
            props = _objectWithoutProperties(_this$props, ["dispatch", "state"]);

        this.currentNavProp = propConstructor(dispatch, state, Navigator.router, this.getCurrentNavigation);
        return React.createElement(Navigator, _extends({}, props, {
          navigation: this.currentNavProp
        }));
      }
    }]);

    return NavigatorReduxWrapper;
  }(React.PureComponent);

  _defineProperty(NavigatorReduxWrapper, "router", Navigator.router);

  return NavigatorReduxWrapper;
}

export { createReduxContainer };